// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__KG27K","wrapper":"Card_wrapper__ZJw_j","headerContainer":"Card_headerContainer__PtONc","bodyContainer":"Card_bodyContainer__mII8H"};